export const externalAccess = {
  "externalAccess.title": "Подключённые приложения",
  "externalAccess.subtitle": "Доступ ваших приложений к чтению и поиску справки Terysling в организации.",
  'externalAccess.failed': 'Не удалось загрузить или изменить подключение. Попробуйте ещё раз.',
  'externalAccess.scopeLost': 'У этого подключения нет нужного разрешения.',
  'externalAccess.accessLost': 'Доступ недоступен. Проверьте аккаунт и членство в организации.',
  'externalAccess.resync': 'Сохранённое сравнение больше не действует. Проверьте и сбросьте наблюдение здесь.',
  'externalAccess.limit': 'Достигнут лимит подключений или хранилища. Удалите ненужные подключения или сузьте наблюдение.',
  'externalAccess.conflict': 'Подключение изменилось в другом месте. Загрузите сохранённое состояние перед повторной попыткой.',
  'externalAccess.throttled': 'Слишком много запросов. Подождите перед повторной попыткой.',
  'externalAccess.missing': 'Это подключение больше недоступно.',
  'externalAccess.invalid': 'Проверьте название, срок действия и настройки наблюдения.',
  'externalAccess.expiryDays': 'Срок доступа в днях (1–365)',
  'externalAccess.noExpiry': 'Бессрочно',
  'externalAccess.watch': 'Наблюдение за обновлениями справки',
  'externalAccess.watchEnabled': 'Включить наблюдение для этого подключения',
  'externalAccess.watchExplain': 'Агент запрашивает снимки и подтверждает их после сохранения отчёта. Эта настройка не запускает расписание.',
  'externalAccess.watchLanguage': 'Предпочтительный язык справки',
  'externalAccess.watchContexts': 'Разделы для наблюдения',
  'externalAccess.allContexts': 'Вся доступная справка',
  'externalAccess.contextsUnavailable': 'Не удалось загрузить доступные разделы. Сохранённый выбор разделов сохранён.',
  'externalAccess.keptContexts': 'Некоторые сохранённые разделы сейчас недоступны. Они остаются выбранными, пока вы не выберете всю справку или не измените выбор.',
  'externalAccess.copy': 'Копировать',
  'externalAccess.copied': 'Скопировано',
  'externalAccess.copyFailed': 'Не удалось скопировать. Выделите и скопируйте значение вручную.',
  'externalAccess.unsaved': 'Несохранённые настройки внешней интеграции',
  'externalAccess.create': 'Создать API-ключ',
  'externalAccess.name': 'Название',
  'externalAccess.read': 'Чтение справки',
  'externalAccess.readDetail': 'Чтение и поиск доступной справки, иллюстраций, контекста разделов и ссылок на приложение. Без доступа к медицинским записям и редактированию содержимого.',
  'externalAccess.sync': 'Отслеживание обновлений справки',
  'externalAccess.syncDetail': 'Хранение технического сравнения и подтверждение обработанных обновлений. Содержимое справки при этом не меняется.',
  'externalAccess.working': 'Сохранение…',
  'externalAccess.consentTitle': 'Подключение агента',
  'externalAccess.consentDetail': 'Проверьте приложение, организацию и разрешения перед предоставлением доступа.',
  'externalAccess.client': 'Приложение, запрашивающее доступ',
  'externalAccess.unverified': 'Название указано самим приложением. Перед подтверждением проверьте адрес возврата и организацию.',
  'externalAccess.loopback': 'Возврат ведёт в локальное приложение. Продолжайте, только если вы начали этот запрос в доверенном клиенте на компьютере.',
  'externalAccess.approve': 'Разрешить доступ',
  'externalAccess.deny': 'Отказать',
  'externalAccess.clinic': 'Организация',
  'externalAccess.callback': 'Адрес возврата',
  'externalAccess.resource': 'Запрашиваемый ресурс',
  'externalAccess.permissions': 'Разрешения',
  'externalAccess.back': 'Вернуться к интеграциям',
  'externalAccess.state.active': 'Активно',
  'externalAccess.state.expired': 'Срок истёк',
  'externalAccess.state.revoked': 'Отозвано',
  'externalAccess.state.unavailable': 'Доступ недоступен',
  'externalAccess.checkpoint.disabled': 'Наблюдение выключено',
  'externalAccess.checkpoint.uninitialized': 'Ожидается первый снимок',
  'externalAccess.checkpoint.ready': 'Сравнение сохранено',
  'externalAccess.checkpoint.pending': 'Ожидается подтверждение агента',
  'externalAccess.checkpoint.expired': 'Сравнение устарело; нужен сброс',
  'externalAccess.unknown': 'Неизвестное состояние',
  'externalAccess.connection': 'Подключение',
  'externalAccess.selectClinic': 'Для изменения настроек выберите в приложении организацию этого подключения. Отзыв доступа остаётся доступен.',
  'externalAccess.rotate': 'Заменить ключ',
  'externalAccess.revoke': 'Отозвать доступ',
  'externalAccess.reload': 'Загрузить сохранённое состояние',
  'externalAccess.reloadFailed': 'Не удалось загрузить сохранённое состояние. Ваш черновик сохранён.',
  'externalAccess.reloaded': 'В форме показано сохранённое состояние.',
  'externalAccess.state': 'Состояние',
  'externalAccess.created': 'Создано',
  'externalAccess.expires': 'Действует до',
  'externalAccess.keyPrefix': 'Начало ключа',
  'externalAccess.lastUsed': 'Последнее использование',
  'externalAccess.lastAck': 'Последний подтверждённый снимок',
  'externalAccess.baselineExpires': 'Сравнение действует до',
  'externalAccess.reset': 'Сбросить сохранённое сравнение и ожидающие обновления',
  'externalAccess.resetExplain': 'Сброс удаляет сохранённое сравнение и неподтверждённый пакет. Следующий запрос создаст новую точку отсчёта. Незавершённый отчёт при этом не считается подтверждённым.',
  'externalAccess.resetRequired': 'Изменение этих настроек требует явного сброса сохранённого сравнения.',
  'externalAccess.save': 'Сохранить наблюдение',
  'externalAccess.revokeTitle': 'Отозвать это подключение?',
  'externalAccess.rotateTitle': 'Заменить этот API-ключ?',
  'externalAccess.revokeDetail': 'Агент сразу потеряет доступ. Это подключение нельзя будет включить снова.',
  'externalAccess.rotateDetail': 'Старый ключ сразу перестанет работать. Наблюдение сохранится. Скопируйте новый ключ после его появления.',
  'externalAccess.kind.oauth': 'Подключённое приложение',
  'externalAccess.kind.key': 'API-ключ',
  'externalAccess.manageNamed': 'Управление: {name}',
  'externalAccess.openNamed': 'Открыть: {name}',
  'externalAccess.secretTitle': 'Ваш новый API-ключ',
  'externalAccess.secretDetail': 'Полный ключ показан только сейчас. Скопируйте его в секретные настройки клиента. Не вставляйте ключ в адреса и сообщения чата.',
  'externalAccess.secretHide': 'Ключ сохранён — закрыть',
  'externalAccess.mcpUrl': 'Адрес MCP',
  'externalAccess.apiUrl': 'Адрес REST API',
  'externalAccess.empty': 'Подключений пока нет',
  'externalAccess.emptyDetail': 'Подключите совместимый клиент через OAuth или создайте ключ в выбранной организации.',
  'externalAccess.addresses': 'Адреса для подключения',
  'externalAccess.copyNamed': 'Копировать: {label}',
  'externalAccess.facts': 'Сведения о подключении',
  'externalAccess.access': 'Доступ',
  'externalAccess.secretDismiss': 'Ключ сохранён — скрыть',
  'externalAccess.readChip': 'Чтение',
  'externalAccess.syncChip': 'Обновления',
  "designAccess.title": "Исходники и предложения дизайна",
  "designAccess.subtitle": "Подключите помощника для чтения исходников и сохранения предложений дизайна. Изменения приложения согласуются и реализуются отдельно.",
  "designAccess.read": "Читать исходники проекта",
  "designAccess.readDetail": "Чтение репозитория, компонентов, стилей и сохранённых предложений. Доступ к клиническим данным не предоставляется.",
  "designAccess.write": "Сохранять предложения дизайна",
  "designAccess.writeDetail": "Сохранение файлов вместе с описанием и историей версий. Это не меняет работающее приложение.",
  "designAccess.consentDetail": "Предоставьте этому клиенту доступ к исходникам и предложениям дизайна от своего аккаунта. Проверьте разрешения и адрес возврата.",
  "designAccess.ineligible": "Вашему аккаунту недоступны исходники и предложения дизайна. Обратитесь к администратору.",
  "designAccess.open": "Управлять подключениями к исходникам и дизайну",
  "designAccess.emptyDetail": "Добавьте адрес MCP как подключение с OAuth в помощнике, затем проверьте и одобрите запрос здесь.",
  "designAccess.cancel": "Сохранить доступ",
  "designProposals.subtitle": "Черновики, которые помощник сохранил через подключение к дизайну. Просмотр черновика не меняет приложение.",
  "designProposals.open": "Открыть черновики дизайна",
  "designProposals.empty": "Черновиков пока нет",
  "designProposals.emptyDetail": "Здесь появятся черновики, которые помощник сохранит через подключение к дизайну.",
  "designProposals.connect": "Как подключить помощника",
  "designProposals.failed": "Не удалось загрузить черновики дизайна. Попробуйте ещё раз.",
  "designProposals.forbidden": "Черновики дизайна доступны только аккаунтам с доступом к исходникам и дизайну.",
  "designProposals.notFound": "Этот черновик или его версия больше недоступны.",
  "designProposals.layoutManifest": "Упорядочено",
  "designProposals.layoutInferred": "Без списка страниц",
  "designProposals.layoutInvalid": "Нужно исправить",
  "designProposals.layoutInferredDetail": "У черновика нет списка страниц, поэтому страницы показаны в порядке файлов.",
  "designProposals.layoutInvalidDetail": "Список страниц этого черновика нельзя использовать, поэтому страницы показаны в порядке файлов. Попросите помощника исправить его.",
  "designProposals.columnTitle": "Черновик",
  "designProposals.columnArea": "Раздел",
  "designProposals.columnLayout": "Структура",
  "designProposals.columnPages": "Страницы",
  "designProposals.columnVersions": "Версии",
  "designProposals.columnUpdated": "Обновлено",
  "designProposals.columnAuthor": "Автор",
  "designProposals.page": "Страница",
  "designProposals.width": "Ширина просмотра",
  "designProposals.widthFull": "Компьютер",
  "designProposals.widthTablet": "Планшет",
  "designProposals.widthPhone": "Телефон",
  "designProposals.fullScreen": "Во весь экран",
  "designProposals.frameTitle": "Страница черновика: {title}",
  "designProposals.version": "Версия",
  "designProposals.versions": "Версии",
  "designProposals.versionOption": "{date} · {author}",
  "designProposals.latest": "последняя",
  "designProposals.savedBy": "Сохранено",
  "designProposals.unknownAuthor": "Неизвестный аккаунт",
  "designProposals.noPages": "У этого черновика нет страниц для показа.",
  "designProposals.explanation": "Пояснение",
  "designProposals.noExplanation": "У этого черновика нет пояснения.",
  "designProposals.olderVersion": "Вы смотрите более раннюю версию.",
  "designProposals.showLatest": "Показать последнюю",
} as const
